
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSpotSoundingsIec as ObiChartSpotSoundingsIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-spot-soundings-iec.js';
 
 
 

 
 export const ObiChartSpotSoundingsIec = createComponent({
   react: React,
   tagName: 'obi-chart-spot-soundings-iec',
   elementClass: ObiChartSpotSoundingsIecElement,
   events: {
     
   }
  });
 
 